// This file contains reusable utility types for zod
import { z } from "zod"

export const zodSortEnum = z.enum(["asc", "desc"])
export type SortEnum = z.infer<typeof zodSortEnum>
